<script>
export default {
    
}
</script>

<template>
    <footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6 d-none d-md-block">{{ new Date().getFullYear()}} © MarcelRichie. (@marcelrichie Telegram)</div>
        </div>
    </div>
</footer>
</template>